module.exports = __webpack_public_path__ + "static/media/chitwan3.e4791023.ogg";